export default __webpack_public_path__ + "static/media/excelsiorPeru.8f8b847b.webp";